import React from "react";
import { Button, Select } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

export default function CustomPagination({
  current = 1,
  pageSize = 10,
  total = 0,
  onChange,
  onPageSizeChange,
}) {
  const totalPages = Math.ceil(total / pageSize);
  const start = total === 0 ? 0 : (current - 1) * pageSize + 1;
  const end = Math.min(current * pageSize, total);

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className="border-t bg-white px-5 py-4 rounded-b-2xl flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <p className="m-0 text-slate-500">
        Showing {start} to {end} of {total} results
      </p>

      <div className="flex items-center justify-center gap-3">
        <Button
          icon={<LeftOutlined />}
          disabled={current === 1}
          onClick={() => onChange?.(current - 1)}
          className="w-10 h-10 rounded-lg"
        />

        {pages.map((page) => (
          <Button
            key={page}
            onClick={() => onChange?.(page)}
            className={`w-10 h-10 rounded-lg font-semibold ${
              current === page
                ? "!bg-purple-600 !text-white !border-purple-600"
                : ""
            }`}
          >
            {page}
          </Button>
        ))}

        <Button
          icon={<RightOutlined />}
          disabled={current === totalPages}
          onClick={() => onChange?.(current + 1)}
          className="w-10 h-10 rounded-lg"
        />
      </div>

      <Select
        value={pageSize}
        className="w-[130px]"
        onChange={(value) => onPageSizeChange?.(value)}
        options={[
          { value: 10, label: "10 / page" },
          { value: 20, label: "20 / page" },
          { value: 50, label: "50 / page" },
        ]}
      />
    </div>
  );
}